var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19410_2988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.46939 0 0 4.46939 0 10C0 15.5306 4.46939 20 10 20C15.5306 20 20 15.5306 20 10C20 4.46939 15.5306 0 10 0ZM10 18.3388C5.40408 18.3388 1.66122 14.5959 1.66122 10C1.66122 5.40408 5.40408 1.66122 10 1.66122C14.5959 1.66122 18.3388 5.40408 18.3388 10C18.3388 14.5959 14.5959 18.3388 10 18.3388Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8735 9.14699H10.8531V5.2327C10.8531 4.76331 10.4694 4.37964 10 4.37964C9.53065 4.37964 9.14697 4.76331 9.14697 5.2327V10C9.14697 10.4694 9.53065 10.8531 10 10.8531H11.8735C12.3429 10.8531 12.7266 10.4694 12.7266 10C12.7266 9.53066 12.3388 9.14699 11.8735 9.14699Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19410_2988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7566e78b68caab65f029f70068d497a0.svg";
export { ForwardRef as ReactComponent };